import React from 'react';
import { Box } from '@chakra-ui/react';
import appConfig from '../Config/appConfig';

const BackgroundWrapper = ({ sections, children }) => {
  const background = sections?.find((section) => section.type === 'background');
  const { imageUrl, color, gradient } = background || {};

  return (
    <Box
      width="100%"
      height="100%"
      bg={gradient || color || 'white'}
      backgroundImage={imageUrl ? `url(${appConfig.ImageBlobBaseUrl}/${imageUrl})` : 'none'}
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
      backgroundPosition="top left"
    >
      {children}
    </Box>
  );
};

export default BackgroundWrapper;
